<template>
  <services-table
    :api-u-r-l="apiURL"
    :title="title"
    module="services"
  />
</template>

<script>
import ServicesTable from '~/components/ServicesTable';

export default {
  middleware: 'auth',
  components: {
    ServicesTable,
  },
  computed: {
    apiURL() {
      return '/api/catalogs/services';
    },
    title() {
      return 'Paquetes';
    },
  },
};
</script>
